<script>
  import dialogMixin from "./mixins/dialog";

  export default {
    mixins: [dialogMixin],
    data() {
      return {
        loadingGetProtection: false,
        ProtectionPageItem: null,
        domain: window.location.hostname,
        isMobileSize: false,
      }
    },
    mounted() {
      const initResizeListener = () => {
        window.addEventListener('resize', this.onMobileSize)
      };

      this.onMobileSize();
      initResizeListener();
    },
    destroyed() {
      const removeResizeListener = () => {
        window.removeEventListener('resize', this.onMobileSize)
      };

      removeResizeListener();
    },
    methods: {
      onMobileSize() {
        this.isMobileSize = document.body.clientWidth <= 767
      },
    },
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogProtection }`"
    width="1300px"
    append-to-body
    :fullscreen="isMobileSize"
  >
    <article class="article">
      <h3 class="text-center text-xl md:text-3xl font-regular">【 個人資料保護法應告知事項及同意書 】</h3>
      <p>
        零壹科技股份有限公司(下稱零壹科技)為保護您的個人資料，
        <br>依據個人資料保護法規定，告知下列相關事項如下：
      </p>
      <ul>
        <li>
          一、蒐集之目的：零壹科技依據個人資料保護法及相關法令之規定，蒐集您的個人資料，為行銷、契約、類似契約或其他法律關係事務、消費者、客戶管理與服務、教育或訓練行政、資（通）訊服務、資（通）訊與資料庫管理、資通安全與管理、廣告或商業行為管理、調查、統計與研究分析、其他經營合於營業登記項目或組織章程所定之業務。
        </li>
        二、個人資料之類別：零壹科技所蒐集您提供之資料，包含姓名、年齡、性別、服務單位、職稱、連絡方式，包括但不限於電話、E-MAIL或地址等或其他得以直接或間接識別您個人之資料。
        <li>
        </li>
        <li>
          三、個人資料利用之期間、地區、對象或方式：
          <ul>
            <li>
              （一）期間：公司依法令或契約約定之資料保存期間或因執行業務所必須之保存期間。
            </li>
            <li>
              （二）地區：獲主管機關許可經營及營業登記項目所定之業務,其營業活動之相關地區及為達蒐集、處理及利用目的所必須使用之相關地區。
            </li>
            <li>
              （三）對象：本公司及集團關係企業、委託本公司舉辦活動之公司或機構、本公司之共同行銷或合作夥伴、與本公司有業務往來或合作之機構、依法有調查權之機關。
            </li>
            <li>
              （四）方式：以數位檔案及實體紙本型態蒐集與利用的個人資料。
            </li>
          </ul>
        </li>
        <li>
          四、個人資料行使之權利及方式：
          <ul>
            <li>
              （一）請求查詢、閱覽或製給複製本，零壹科技依法得酌收必要成本費用。
            </li>
            <li>
              （二）請求補充或更正之。
            </li>
            <li>
              （三）請求刪除、停止處理或利用您的個人資料。但法令另有規定者，不在此限。
            </li>
          </ul>
        </li>
        <li>
          五、若您不願意提供您的個人資料予零壹科技依上述說明內容為蒐集、處理及利用，您將無法參加本活動。有任何問題請您可與零壹科技客服人員聯繫
          (e-mail:marketing@zerone.com.tw)電話（02-26565656) 。
        </li>
      </ul>
    </article>
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogProtection {
    :global {

    }
  }
</style>
